import { ProductAccountDTO } from 'api-models'
import {
	GAdminDashboardTable,
	GLoading,
	GSection
} from 'components/basic-blocks'
import { useStores } from 'hooks'
import { useEffect, useState } from 'react'
import { RiErrorWarningLine } from 'react-icons/ri'
import { useUiStore } from 'store'
import { columns } from './columns'
import { MRRBreakDownByPrice, potentialLostMRR } from 'utils'

export const CancelRequestsTab = () => {
	const { adminStore } = useStores()
	const { loadAccounts, downloadAccounts, getPipeline } = adminStore
	const isLoading = useUiStore((s) => s.isLoading)

	const [state, setState] = useState<any>({})
	const [skip, setSkip] = useState(0)
	const [query, setQuery] = useState({ cancel_request: true, sort: '' })

	useEffect(() => {
		;(async () => {
			const accounts = await loadAccounts({ ...query, skip })
			const pipeline = await getPipeline({ ...query })
			setState({ accounts, pipeline })
		})()
	}, [query.sort])

	const handleSort = (key: string) => {
		setQuery({ ...query, sort: key })
	}

	if (!state.accounts || !state.pipeline) return <GLoading />

	return (
		<>
			<GSection className="" loading={isLoading('ADMIN_GET_ACCOUNTS')}>
				<GAdminDashboardTable<ProductAccountDTO>
					columns={columns}
					refreshAction={async () => {
						const accounts = await loadAccounts(query)
						setState({ accounts })
					}}
					downloadAction={async () => {
						await downloadAccounts(query, 'cancel-requests')
					}}
					potentialMRR={
						<>
							<div className="w-full flex items-center justify-between">
								<div className="font-bold text-xl text-t-default mx-1">
									Lost MRR
								</div>
								<div className="font-bold text-xl text-red-500 mx-1">
									- {potentialLostMRR(state.pipeline.cancel_request)}
								</div>
							</div>
						</>
					}
					MRRBreakdownByPlan={MRRBreakDownByPrice(
						state.pipeline.cancel_request
					)}
					actionButtonsPlacement="bottom"
					isDownloadable={true}
					title="Cancel requests"
					data={state.accounts.data}
					pageSize={state.pageSize}
					sortListener={handleSort}
					sort={query.sort}
					skip={skip}
					setSkip={setSkip}
					totalCount={state.accounts.total}
					emptyState={
						<div className="flex flex-col items-center justify-center w-full p-8 text-center">
							<RiErrorWarningLine className="w-8 h-8 text-gray-500" />
							<h3 className="mt-2 text-sm font-medium text-gray-700">
								No data
							</h3>
						</div>
					}
				/>
			</GSection>
		</>
	)
}
